import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Grid } from '@mui/material';
import RoomList from '../../components/RoomList';
import './inprogress.css'

const InProgressPage = props => {
  const [selectedRoom, setSelectedRoom] = useState();
  const [openChat, setOpenChat] = useState(true);
  const location = useLocation();
  // Abre direto o chat da aba do quickaccess: o roomId pode vir pelo state
  // (navegação interna) ou pela query (?roomId=...), que é o caso das abas.
  const initialRoomId = location.state?.roomId
    || new URLSearchParams(location.search).get('roomId');

  return (
    <Grid className="compact" sx={{ paddingRight: 0, paddingLeft: 0, width: '100%', height: '100%' }}>
      <RoomList
        openChat={openChat}
        setOpenChat={setOpenChat}
        selectedRoom={selectedRoom}
        setSelectedRoom={setSelectedRoom}
        dimensions={props.dimensions}
        initialRoomId={initialRoomId}
      />
    </Grid>
  );
};

const mapStateToProps = state => {
  const { rooms, } = state;
  const { inProgressRooms } = rooms;
  return { inProgressRooms, };
};

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, null)(InProgressPage);
